// User Data Utilities - Clear user data to prevent account confusion
// This ensures new users don't accidentally use previous user's data

import { authService } from '@/features/auth/services/authService';

/**
 * Clears all user-related data from the application
 * This should be called when:
 * - User navigates to platform selection
 * - User navigates to action selection  
 * - User navigates to registration
 * - User logs out
 */
export const clearUserData = () => {
    console.log('🧹 Clearing user data to prevent account confusion...');

    // Clear authentication service state
    authService.reset();

    // Clear any localStorage items (if used)
    const keysToRemove = [
        'user_token',
        'user_email',
        'user_session',
        'auth_token',
        'refresh_token',
        'selected_provider',
        'deposit_amount'
    ];

    keysToRemove.forEach(key => {
        try {
            localStorage.removeItem(key);
            sessionStorage.removeItem(key);
        } catch (error) {
            // Ignore errors (localStorage might not be available)
            console.warn(`Could not clear ${key}:`, error);
        }
    });

    // Clear any cookies (if used)
    try {
        document.cookie.split(";").forEach(cookie => {
            const eqPos = cookie.indexOf("=");
            const name = eqPos > -1 ? cookie.substr(0, eqPos).trim() : cookie.trim();
            if (name && keysToRemove.some(key => name.includes(key))) {
                document.cookie = `${name}=;expires=Thu, 01 Jan 1970 00:00:00 GMT;path=/`;
            }
        });
    } catch (error) {
        console.warn('Could not clear cookies:', error);
    }

    console.log('✅ User data cleared successfully');
};

/**
 * Clears user data and logs the reason
 */
export const clearUserDataWithReason = (reason: string) => {
    console.log(`🧹 Clearing user data: ${reason}`);
    clearUserData();
};

/**
 * Checks if user data exists and warns if found
 */
export const checkForExistingUserData = () => {
    const hasUserData = keysToRemove.some(key => {
        try {
            return localStorage.getItem(key) || sessionStorage.getItem(key);
        } catch {
            return false;
        }
    });

    if (hasUserData) {
        console.warn('⚠️ Existing user data found - clearing to prevent confusion');
        clearUserData();
    }
};

// List of keys that should be cleared
const keysToRemove = [
    'user_token',
    'user_email',
    'user_session',
    'auth_token',
    'refresh_token',
    'selected_provider',
    'deposit_amount'
];
